import * as React from "react";
import ChangeEnum from "../../interfaces/frontend/ChangeEnum";
import Icons from "../Icons";
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InhibitorDiffOptions } from "../InhibitorDiffOptions";
import { useCallback } from "react";

interface Props {
  value: ChangeEnum | null,
  setValue: (value: ChangeEnum | null) => void,
}

export function InhibitorSelectDiff({value, setValue}: Props) {
  const handleChange = useCallback((e: DropdownChangeEvent) => setValue(e.value ?? null), [setValue]);
  return <Dropdown
    optionLabel="icon"
    value={value}
    options={InhibitorDiffOptions}
    onChange={handleChange}
    placeholder="Filter by difference..."
    valueTemplate={selectedTemplate}
    itemTemplate={renderOption}
    showClear
    scrollHeight="none"
    className="ll-inhibitor-select-diff"
    panelClassName="ll-inhibitor-select-diff-panel"
  />
}

function renderOption(option) {
  return (
    <span className="ll-inhibitor-select-diff-option">
      <span>{Icons[option.icon]}</span>
      {option.label}
    </span>
  )
}

const selectedTemplate = (i, props) => {
  if (i) {
    return renderOption(i);
  }
  return (
    <span className="ll-inhibitor-select-diff-option">
        <span className="pi pi-filter" style={{ lineHeight: 'inherit' }} />
      {props.placeholder}
      </span>
  )
}